import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom"
import { useStoreActions, useStoreState } from "../../store/data-store";

const Header = () => {

    const isLoggedIn = useStoreState(store => store.isLoggedIn);
    const user = useStoreState(store => store.user);
    const setUser = useStoreActions(store => store.setUser);
    const setLoggedIn = useStoreActions(store => store.setLoggedIn);
    const [menuClass, setMenuClass] = useState("");

    useEffect(() => {
        if( !isLoggedIn )
        {
            setMenuClass("mobile-hidden")
        }

    },[])

    const navigate = useNavigate();

    const logout = () => {
        setLoggedIn(false);
        setUser({
            id: '',
            name: '',
            emailAddress: '',
            refreshToken: ''
        });
        toggleMenu(); 
        navigate("/");
    }

    const toggleMenu = () => {
        if( menuClass === "mobile-hidden"){
            setMenuClass("");
        }
        else {
            setMenuClass("mobile-hidden");
        }

    }

    return (
        <header>
            <div className="master-title">Stitch Bean<div className='user-name'>{user.name}</div></div>
            <FontAwesomeIcon icon="bars" onClick={toggleMenu} className="mobile-menu"></FontAwesomeIcon>
            { !isLoggedIn ?
                <nav className={'header-nav ' + menuClass} >
                    <Link to="/login" onClick={toggleMenu}>Login</Link>
                </nav>
                :
                <nav className={'header-nav ' + menuClass}>
                    <Link to="/projects" onClick={toggleMenu} >Projects</Link>
                    <Link to="/inventory" onClick={toggleMenu} >Inventory</Link>
                    <Link to="/shopping" onClick={toggleMenu} >Shopping</Link>
                    <div className="functional-link logout" onClick={logout}>Logout</div>
                </nav>
            }   
        </header>
    )

}
export default Header;